// Collect + group for the wait lens, on the factory's layers.
import { extractWaitOps } from "./index.js";
import { collectWindowOps, groupActivity, distinctKey } from "../../src/build/index.js";

export const extract = extractWaitOps;

// A later sighting knows more when it captured the resolution. Bodies are
// cumulative, so a wait is first seen before the loop reported anything.
const RANK = { "observed-ready": 3, "gave-up": 2, unrecoverable: 1 };
export const informedness = (op) => (RANK[op.outcome] || 0) * 10000 + (op.output?.length || 0);
export const collect = (prompts) => collectWindowOps(prompts, { informedness });

// The unit a reader scans is WHAT WAS WAITED ON — the dependency the session was
// blocked behind. Repeated waits on the same kind of thing are the same story.
export const groupBy = (op) => op.waitingFor || distinctKey("unclassified wait", op);

export const build = (flat) => groupActivity(flat, {
  key: groupBy,
  label: (op) => `waiting on ${op.phrase}`,
  seed: () => ({ outcomes: {}, labels: [], budgets: [], payoff: [], unbounded: 0 }),
  fold: (g, op) => {
    g.outcomes[op.outcome] = (g.outcomes[op.outcome] || 0) + 1;
    if (op.budgetSecs == null) g.unbounded += 1;
    else if (!g.budgets.includes(op.budgetSecs)) g.budgets.push(op.budgetSecs);
    for (const p of op.payoff || []) if (!g.payoff.includes(p)) g.payoff.push(p);
  },
  // The budget spread is the group's summary line: "up to 200s" tells a reader how
  // long this session was willing to sit behind this dependency.
  finish: (g) => {
    const max = g.budgets.length ? Math.max(...g.budgets) : null;
    g.labels = [
      max != null ? `up to ${max}s` : null,
      g.unbounded ? `${g.unbounded} unbounded` : null,
      ...g.payoff.slice(0, 4),
    ].filter(Boolean);
  },
});

export const anchor = () => "sleep";
export const ignore = ["output", "probe", "readyLine", "steps", "checks"];
